module.exports = __webpack_public_path__ + "static/media/sec.8e6c1c8e.png";